<template>
  <div class="view search" id="minHeight">
    <banner v-if="showAuthBanner" v-on:closeBanner="showAuthBanner = false"></banner>
    <div class="top-bar top-bar--has-height">
      <router-link to="/" tag="div" class="home-btn" :class="activeCloseBtn ? 'active' : ''">
        <img src="@/assets/icons/arrow.svg" alt="Home" @click="playSound()">
      </router-link>
      <div class="search-field">
        <img class="input-icon input-icon--search" src="@/assets/icons/input_search.svg" alt="Search">
        <img
          class="input-icon input-icon--clear"
          src="@/assets/icons/input_clear.svg"
          alt="Clear"
          v-if="this.hasSearchTerm"
          @click="() => {setSearchCategory(''), this.showNoResult = false;}"
        >
        <input type="text" @input="isTyping = true" v-model="keyWord" autofocus="true" ref="searchBar">
      </div>
    </div>

    <div class="no-result-cover" v-if="showNoResult">
      <div class="no-result">
        <img src="@/assets/icons/no_result.svg" alt="No Result">
        <span>RESULTS NOT FOUND</span>
      </div>
    </div>

    <div class="search-categories" v-if="!hasSearchTerm && !isTyping">
      <SearchCategoryCard
        v-for="item in contentOptionsDispaly"
        v-if="item.value !== 0"
        :is-selected="resultType === item.value"
        @click="setSearchCategory(item.value)"
        :display-label="item.display"
        :icon-src="item.img"
      />
    </div>

    <div class="items-wrap" v-if="items.length > 0">
      <Slider ref="slider"  @scroll="onScroll">
        <FolderCard ref="cards" 
          v-for="(item, index) in items" 
          :key="(item.identifier + index)" 
          :item="item" 
          :selected="selectedKey === item.identifier"
          :selectedHeart="selectedKey === item.identifier && selectedHeart"
          @mouseover.native="onCardMouseOver(item)" 
          @mouseleave.native="onCardMouseLeave(item)"
          @click.native="onFolderClick(item, items)"
        />
      </Slider>
    </div>
  </div>
</template>
<script>
  import { CardColor } from '@/services/cards.service';
  import SearchCategoryCard from '@/components/SearchCategoryCard.vue';
  import Slider from '@/components/Slider.vue';
  import FolderCard from '@/components/FolderCard.vue';
  import Banner from '@/components/Banner.vue';
  import cardsService from '@/services/cards.service';
  import { contentOptions } from '@/utils/settings.options';
  import { Events } from '@/models/analytics';
  import { soundList, soundPlayer } from '@/utils/sounds';

  const baseUrl = process.env.VUE_APP_CARDS_API;

  export default {
    components: { SearchCategoryCard, FolderCard, Slider, Banner },
    data() {
      return {
        imageDeviceType: 'phone-m',
        items: [],
        isScrolling: false,
        selectedKey: null,
        selectedIndex: 0,
        selectedHeart: false,
        isSearchKeyword: null,
        keyWord: '',
        resultType: 0,
        isTyping: false,
        oldSelectedIndex: 0,
        horizontalVisibleCardCount: 0,
        showNoResult: false,
        loadingResult: false,
        minMobileHeight: 0,
        showAuthBanner: false,
        activeCloseBtn: false,
        activeSearchBar: false,
      };
    },
    computed: {
      contentOptionsDispaly() {
        return this.selectedContentType === 0 ? contentOptions : contentOptions.filter(obj => obj.value === this.selectedContentType);
      },
      selectedContentType() {
        return this.$store.getters['settings/getContentType'] || 0;
      },
      isAgeSettingDisplayed() {
        return this.$store.getters['settings/isAgeSettingDisplayed'];
      },
      getBannerState() {
        return this.$store.getters['settings/getBannerState'];
      },
      getAge() {
        return this.$store.getters['settings/getAge'];
      },
      getLanguage() {
        return this.$store.getters['settings/getLanguage'];
      },
      getPremium() {
        return this.$store.getters['account/getPremium'];
      },
      hasSearchTerm() {
        const { keyWord } = this;
        return typeof keyWord === 'string' && keyWord !== '';
      },
    },
    methods: {
      playSound() {
        soundPlayer(soundList.general);
      },
      setVideoList(val) {
        this.$store.dispatch('settings/setVideoList', val);
      },
      setBannerState(val) {
        this.$store.dispatch('settings/setBannerState', val);
      },
      setOldSearch() {
        const key = localStorage.getItem('lastSearch');
        const typeKey = localStorage.getItem('lastContentType');

        if (key) {
          this.keyWord = key;
          localStorage.removeItem('lastSearch');
          this.search();
        }
        if (typeKey) {
          this.resultType = typeKey;
          localStorage.removeItem('lastContentType');
          this.search();
        }
      },
      isAndroidDevice() {
        return !!navigator.userAgent && /Android/i.test(navigator.userAgent);
      },
      handleKeyboard(event) {
        event.preventDefault();
        const indexDelta = this.getIndexDelta(event);
        const oldIndex = this.selectedIndex || 0;

        if (this.selectedIndex === null) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex += indexDelta;
        }

        this.autoScrollIfNeeded(oldIndex, this.selectedIndex);

        if (this.selectedIndex >= 0 && this.selectedIndex < this.items.length) {
          this.selectedKey = this.items[this.selectedIndex].identifier;
        } else {
          this.selectedKey = '';
        }

        const item = this.getSelectedItem();

        if (!this.getBannerState) {
          try {
            if (!this.isAgeSettingDisplayed) {
              switch (event.keyCode) {
                case VK_ENTER: {
                  if (this.activeCloseBtn) {
                    this.goBack();
                  } else if (item) {
                    this.onFolderClick(item, this.items, true);
                  }
                }
              }
            }
          } catch (error) {
            switch (event.code) {
              case 'Enter': {
                if (this.activeCloseBtn) {
                  this.goBack();
                } else if (item) {
                  this.onFolderClick(item, this.items, true);
                }
              }
            }
          }
        }
      },
      goBack() {
        this.$router.push('/');
      },
      triggerResize() {
        const resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent.initEvent('resize', true, false);
        window.dispatchEvent(resizeEvent);
      },
      getIndexDelta(event) {
        let delta = 0;
        if (!this.getBannerState) {
          try {
            if (!this.isAgeSettingDisplayed) {
              switch (event.keyCode) {
                case VK_UP: {
                  if (!this.activeSearchBar || !this.activeCloseBtn) {
                    this.activeSearchBar = true;
                    this.$refs.searchBar.focus();
                  }

                  break;
                }
                case VK_DOWN: {
                  if (this.activeSearchBar || this.activeCloseBtn) {
                    this.activeCloseBtn = false;
                    this.activeSearchBar = false;
                    this.$refs.searchBar.blur();
                  }

                  break;
                }
                case VK_LEFT: {
                  if (!this.activeSearchBar && !this.activeCloseBtn) {
                    if (this.selectedIndex != null && this.selectedIndex > 0) {
                      delta--;
                      this.oldSelectedIndex = this.selectedIndex + delta;
                    }
                  } else if (this.activeSearchBar) {
                    this.activeSearchBar = false;
                    this.$refs.searchBar.blur();
                    this.activeCloseBtn = true;
                  }

                  break;
                }
                case VK_RIGHT: {
                  if (!this.activeSearchBar && !this.activeCloseBtn) {
                    if (this.selectedIndex != null && this.selectedIndex < this.items.length - 1 && this.selectedIndex > -1) {
                      delta++;
                      this.oldSelectedIndex = this.selectedIndex + delta;
                    } else if (this.selectedIndex && this.selectedIndex < 0) {
                      this.selectedIndex = this.oldSelectedIndex;
                    }
                  } else if (this.activeCloseBtn) {
                    this.activeCloseBtn = false;
                    this.activeSearchBar = true;
                    this.$refs.searchBar.focus();
                  }

                  break;
                }
              }
            }
          } catch (error) {
            switch (event.code) {
              case 'ArrowLeft': {
                if (!this.activeSearchBar && !this.activeCloseBtn) {
                  if (this.selectedIndex != null && this.selectedIndex > 0) {
                    delta--;
                  }
                } else if (this.activeSearchBar) {
                  this.activeSearchBar = false;
                  this.$refs.searchBar.blur();
                  this.activeCloseBtn = true;
                }

                break;
              }
              case 'ArrowRight': {
                if (!this.activeSearchBar && !this.activeCloseBtn) {
                  if (this.selectedIndex != null && this.selectedIndex < this.items.length - 1) {
                    delta++;
                  }
                } else if (this.activeCloseBtn) {
                  this.activeCloseBtn = false;
                  this.activeSearchBar = true;
                  this.$refs.searchBar.focus();
                }
                break;
              }
              case 'ArrowDown': {
                if (this.activeSearchBar || this.activeCloseBtn) {
                  this.$refs.searchBar.blur();
                  this.activeCloseBtn = false;
                  this.activeSearchBar = false;
                }

                break;
              }
              case 'ArrowUp': {
                if (!this.activeSearchBar || !this.activeCloseBtn) {
                  this.activeSearchBar = true;
                  this.$refs.searchBar.focus();
                }

                break;
              }
            }
          }
        }

        return delta;
      },
      autoScrollIfNeeded(oldIndex, newIndex) {
        const count = this.horizontalVisibleCardCount;
        const delta = oldIndex - newIndex;
        const direction = delta === 0 ? null : delta > 0 ? 'reverse' : 'forward';
        const slider = this.$refs.slider;
        const size = this.$refs.cards && this.$refs.cards.length > 0
          ? (this.$refs.cards[0].$el).offsetWidth + 20 : 0;
        if (newIndex > count / 2 && direction === 'forward') {
          slider.scrollHorizontally(size);
        } else if (direction === 'reverse') {
          slider.scrollHorizontally(-size);
        }
      },
      getSelectedItem() {
        return this.items.find((item) => item.identifier === this.selectedKey);
      },
      async search() {
        this.loadingResult = true;
        const folderColor = this.$route.params.color && this.$route.params.color !== 'white' ? this.$route.params.color : CardColor.Red;
        cardsService.getSearchData({
          resultType: this.resultType,
          searchKey: this.isSearchKeyword ? this.keyWord : ''
        })
          .then((response) => {
            if (response.status === 200 && response.data.videos.length > 0) {
              this.showNoResult = false;
              this.items = response.data.videos.map((subVideo) => {
                return {
                  identifier: subVideo.id,
                  imageUrl: subVideo.id ? `https://d22oud9a7xyyql.cloudfront.net/V2/${this.imageDeviceType}/${subVideo.id}.png` : null,
                  title: subVideo.title,
                  duration: subVideo.duration,
                  premium: true,
                  color: folderColor,
                  };

              });
              this.loadingResult = false;
            } else {
              this.items = [];
              this.showNoResult = (!this.hasSearchTerm ? false : true);
              this.loadingResult = false;
            }

          }).catch((error) => error);
          
        if (localStorage.getItem('kidj_ut')) {
            this.$store.dispatch('analytics/updateAnalyticsQuery', { category: this.resultType, title: this.isSearchKeyword ? this.keyWord : '' });
            this.$store.dispatch('analytics/postAnalytics', Events.SEARCH, { root: true });
        }
      },
      setSearchCategory(type) {
        this.isSearchKeyword = false;
        if (type !== 0 && type !== '') {
          this.keyWord = this.contentOptionsDispaly.filter(obj => obj.value === type)[0].display;
        } else {
          this.keyWord = '';
        }
        if (this.contentOptionsDispaly.filter(obj => obj.value === type).length > 0 && type !== this.resultType) {
          this.resultType = this.contentOptionsDispaly.filter(obj => obj.value === type)[0].value;
          this.search();
        } else {
          this.resultType = this.contentOptionsDispaly[0].value;
          this.items = [];
        }
      },
      onScroll(scrollInfo) {
        this.isScrolling = scrollInfo.horizontal.directionX === 'left'
        || scrollInfo.horizontal.directionX === 'right'
        || scrollInfo.vertical.directionY === 'down'
        || scrollInfo.vertical.directionY === 'up';
      },
      onFolderClick(item, items, keyboardAction = false) {
        if (this.canOpenFolder(item)) {
          let flag = false;
          const itemsList = [];
          items.forEach((element) => {
            if (flag) {
              itemsList.push(element);
            }
            if (item.identifier === element.identifier) {
              flag = true;
            }
          });
          this.saveLastSearch();
          this.saveLastContentType();
          this.setVideoList(itemsList);
          this.$ga.event('video', 'play', `${item.identifier}`);
          this.$router.push({ name: 'player', params: { videoId: item.identifier } });
        } else {
          this.setBannerState(true);
          this.showAuthBanner = true;
        }
      },
      canOpenFolder(item) {
        return !item.premium || this.getPremium;
      },
      saveLastSearch() {
        localStorage.setItem('lastSearch', this.keyWord);
      },
      saveLastContentType() {
        localStorage.setItem('lastContentType', this.resultType);
      },
      onCardMouseOver(item) {
        this.selectedKey = item.identifier;
        this.oldSelectedIndex = this.items.findIndex(this.findIndexLoc);
      },
      findIndexLoc(element) {
        return element.identifier === this.selectedKey;
      },
      onCardMouseLeave() {
        this.selectedKey = null;
      },
    },
    mounted() {
      this.activeSearchBar = true;
      this.setOldSearch();
      document.addEventListener('keyup', this.handleKeyboard);
    },
    destroyed() {
      document.removeEventListener('keyup', this.handleKeyboard);
    },
    watch: {
      keyWord() {
        setTimeout(() => {
          this.isTyping = false;
        }, 2000);
      },
      isTyping() {
        if (!this.isTyping) {
          if (!this.hasSearchTerm) {
            this.setSearchCategory('');
          }
          this.isSearchKeyword = true;
          this.resultType = 0;
          this.search();
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../assets/styles/breakpoints.scss';

  .search {
    box-sizing: border-box;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/backgrounds/bg_stars.svg');
    background-color: #29b6f6;
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;

    .no-result-cover {
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      width: 100%;
      height: 100%;

      @media (orientation: portrait) {
        position: absolute;
      }
      @media (orientation: landscape) {
        position: relative;
      }

      .no-result {
        img {
          width: 100%;
          height: 100%;
          max-width: 120px;
        }

        span {
          display: block;
          margin-top: 10px;
          font-family: "Nunito-ExtraBold";
          font-size: 14px;
          color: #ffffff;

          @media (min-width: 768px) {
            font-size: 18px;
          }

          @media (min-height: 1024px) {
            font-size: 24px;
          }
        }
      }
    }

    .search-categories {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
      gap: 14px;
      width: 100%;
      height: 100%;
    }
  }

  .top-bar {
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (orientation: portrait) {
      box-sizing: border-box;
      height: 74px;
      padding: 10px 10px 0;
    }

    img {
      vertical-align: middle;
    }

    .home-btn {
      cursor: pointer;
      outline: none;

      @media (orientation: landscape) {
        position: absolute;
        top: 10px;
        left: 10px;

        @media (min-width: $breakpoint-lg) {
          top: 20px;
          left: 20px;
        }
      }

      &.active {
        transform: scale(1.1);
      }

      &:hover,
      &:focus {
        transform: scale(1.1);
      }
      img {
        width: 60px;
        height: 60px;

        @media (min-width: $breakpoint-lg) {
          width: 75px;
          height: 75px;
        }
        @media (max-width: 390px) {
          width: 50px;
          height: 50px;
        }
      }
    }

    .search-field {
      box-sizing: border-box;
      // padding: 3px;
      text-align: center;
      background: white;
      border-radius: 29px;
      border-radius: 42px;
      border: 6px solid rgb(8 151 216 / 44%);

      @media (orientation: portrait) {
        position: relative;
        width: 70%;
      }

      @media (orientation: landscape) {
        position: absolute;
        top: 10px;
        left: 0;
        right: 0;
        width: 70%;
        max-width: 340px;
        margin: auto;

        @media (min-width: $breakpoint-sm) {
          max-width: 380px;
        }

        @media (min-width: $breakpoint-lg) {
          top: 20px;
          max-width: 460px;
          border-radius: 38px;
          border-radius: 42px;
        }
      }

      .input-icon {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;

        &--search {
          left: 18px;
          pointer-events: none;
        }

        &--clear {
          right: 26px;
          cursor: pointer;
        }
      }

      input {
        box-sizing: border-box;
        height: 48px;
        line-height: 54px;
        padding: 0 40px;
        // border: 2px solid #6d4c41;
        border-radius: 29px;
        border: none;
        outline: none;
        font-size: 14px;
        font-family: 'Nunito-ExtraBold', serif;
        width: 100%;
        box-sizing: border-box;

        @media (min-width: $breakpoint-lg) {
          height: 69px;
          line-height: 69px;
          font-size: 18px;
          border-radius: 38px;
        }
      }
    }
  }

  .items-wrap {
    position: relative;

    @media (orientation: portrait) {
      height: 100%;

      .top-bar--has-height + & {
        height: calc(100% - 74px);
      }
    }

    @media (orientation: landscape) {
      height: 100%;
    }
  }
</style>